import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Card, Form, Row, Col, ButtonGroup, Spinner, ProgressBar, Table } from 'react-bootstrap';
import { Formik, FieldArray } from 'formik';
import * as yup from 'yup';
import { useQuery } from 'react-query';
import Select from 'react-select';
import { Button } from '@components';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Get } from '@app/utils/httpProvider';
import {
    PHAMVIHANHNGHE_API,
    FILE_MANAGER_API,
    BaseGatewayImage
} from '@app/utils/apiUrl';
import { getToken } from '@app/utils/helper';
import { acceptDoc } from '@app/utils/define';

const LOAI_GIAY_PHEP_OPTIONS = [
    { value: 'GPHN', label: 'Giấy phép hành nghề' },
    { value: 'CCHN', label: 'Chứng chỉ hành nghề' }
];

const NOI_CAP_OPTIONS = [
    { value: 'boQuocPhong', label: 'Bộ quốc phòng' },
    { value: 'khac', label: 'Khác' }
];

// Mảng danh sách Option cho BÁC SĨ
const TEN_CHUNG_CHI_OPTIONS_BACSI = [
    { value: 'Ngoại Thần kinh - Sọ não', label: 'Ngoại Thần kinh - Sọ não' },
    { value: 'Ngoại Tim mạch - Lồng ngực', label: 'Ngoại Tim mạch - Lồng ngực' },
    { value: 'Ngoại Tiết niệu - Sinh dục', label: 'Ngoại Tiết niệu - Sinh dục' },
    { value: 'Ngoại Tiêu hóa', label: 'Ngoại Tiêu hóa' },
    { value: 'Chấn thương - Chỉnh hình', label: 'Chấn thương - Chỉnh hình' },
    { value: 'Ngoại Cột sống', label: 'Ngoại Cột sống' },
    { value: 'Hồi sức cấp cứu và chống độc', label: 'Hồi sức cấp cứu và chống độc' },
    { value: 'Nhi khoa', label: 'Nhi khoa' },
    { value: 'Lao (Ngoại lao)', label: 'Lao (Ngoại lao)' },
    { value: 'Da liễu', label: 'Da liễu' },
    { value: 'Tâm thần', label: 'Tâm thần' },
    { value: 'Nội tiết', label: 'Nội tiết' },
    { value: 'Gây mê hồi sức', label: 'Gây mê hồi sức' },
    { value: 'Bỏng', label: 'Bỏng' },
    { value: 'Phụ sản', label: 'Phụ sản' },
    { value: 'Mắt', label: 'Mắt' },
    { value: 'Tai - Mũi - Họng', label: 'Tai - Mũi - Họng' },
    { value: 'Răng - Hàm - Mặt', label: 'Răng - Hàm - Mặt' },
    { value: 'Dinh dưỡng lâm sàng', label: 'Dinh dưỡng lâm sàng' },
    { value: 'Y học thực nghiệm', label: 'Y học thực nghiệm' },
    { value: 'Y học dự phòng', label: 'Y học dự phòng' },
    { value: 'Dịch tễ học', label: 'Dịch tễ học' },
    { value: 'Khoa học thần kinh', label: 'Khoa học thần kinh' },
    { value: 'Nội Hô hấp', label: 'Nội Hô hấp' },
    { value: 'Nội Tim mạch', label: 'Nội Tim mạch' },
    { value: 'Nội Thần kinh', label: 'Nội Thần kinh' },
    { value: 'Nội Thận tiết niệu', label: 'Nội Thận tiết niệu' },
    { value: 'Nội Tiêu hóa', label: 'Nội Tiêu hóa' },
    { value: 'Cơ xương khớp', label: 'Cơ xương khớp' },
    { value: 'Phục hồi chức năng', label: 'Phục hồi chức năng' },
    { value: 'Điện quang', label: 'Điện quang' },
    { value: 'Y học hạt nhân', label: 'Y học hạt nhân' },
    { value: 'Nội soi chẩn đoán can thiệp', label: 'Nội soi chẩn đoán can thiệp' },
    { value: 'Thăm dò chức năng', label: 'Thăm dò chức năng' },
    { value: 'Huyết học - Truyền máu', label: 'Huyết học - Truyền máu' },
    { value: 'Hóa sinh', label: 'Hóa sinh' },
    { value: 'Vi sinh - Ký sinh trùng', label: 'Vi sinh - Ký sinh trùng' },
    { value: 'Giải phẫu và tế bào học', label: 'Giải phẫu và tế bào học' },
    { value: 'Vi phẫu', label: 'Vi phẫu' },
    { value: 'Phẫu thuật nội soi', label: 'Phẫu thuật nội soi' },
    { value: 'Tạo hình thẩm mỹ', label: 'Tạo hình thẩm mỹ' },
    { value: 'Y học cổ truyền', label: 'Y học cổ truyền' },
    { value: 'Khoa học Y sinh', label: 'Khoa học Y sinh' },
    { value: 'Bệnh truyền nhiễm và các bệnh nhiệt đới', label: 'Bệnh truyền nhiễm và các bệnh nhiệt đới' },
    { value: 'Điện quang và Y học hạt nhân', label: 'Điện quang và Y học hạt nhân' },  
    { value: 'Phẫu thuật tạo hình, tái tạo và thẩm mỹ', label: 'Phẫu thuật tạo hình, tái tạo và thẩm mỹ' },
    { value: 'Truyền nhiễm', label: 'Truyền nhiễm' },

    { value: 'Ung bướu', label: 'Ung bướu' },
    { value: 'Y khoa', label: 'Y khoa' },
    { value: 'Chuyên khoa dinh dưỡng', label: 'Chuyên khoa dinh dưỡng' },
    { value: 'Ngoại Gan - Mật - Tụy', label: 'Ngoại Gan - Mật - Tụy' },
    { value: 'Khác', label: 'Khác' },
];

const SELECT_TEN_CHUNG_CHI_TYPES_BACSI = [
    'Bác sĩ', 'Thạc sĩ', 'Tiến sĩ', 'Chuyên khoa I', 'Chuyên khoa II', 'Nội trú', 'Chứng chỉ chuyên môn kỹ thuật trên 09 tháng',
];

// Mảng danh sách Option cho ĐIỀU DƯỠNG / KỸ THUẬT Y
const TEN_CHUNG_CHI_OPTIONS_DIEUDUONG = [
    { value: 'Hồi sức cấp cứu', label: 'Hồi sức cấp cứu' },
    { value: 'Nội khoa', label: 'Nội khoa' },
    { value: 'Da liễu', label: 'Da liễu' },
    { value: 'Tâm thần', label: 'Tâm thần' },
    { value: 'Nội tiết', label: 'Nội tiết' },
    { value: 'Y học cổ truyền', label: 'Y học cổ truyền' },
    { value: 'Gây mê hồi sức', label: 'Gây mê hồi sức' },
    { value: 'Ngoại khoa', label: 'Ngoại khoa' },
    { value: 'Bỏng', label: 'Bỏng' },
    { value: 'Ung bướu', label: 'Ung bướu' },
    { value: 'Mắt', label: 'Mắt' },
    { value: 'Tai - Mũi - Họng', label: 'Tai - Mũi - Họng' },
    { value: 'Tạo hình thẩm mỹ', label: 'Tạo hình thẩm mỹ' },
    { value: 'Răng - Hàm - Mặt', label: 'Răng - Hàm - Mặt' },
    { value: 'Phụ sản', label: 'Phụ sản' },
    { value: 'Hộ sinh', label: 'Hộ sinh' },
    { value: 'Sản phụ khoa', label: 'Sản phụ khoa' },

    { value: 'Phục hồi chức năng', label: 'Phục hồi chức năng' },
    { value: 'Hình ảnh Y học', label: 'Hình ảnh Y học' },
    { value: 'Xét nghiệm Y học', label: 'Xét nghiệm Y học' },
    { value: 'Khúc xạ nhãn khoa', label: 'Khúc xạ nhãn khoa' },
    { value: 'Dinh dưỡng lâm sàng', label: 'Dinh dưỡng lâm sàng' },

    { value: 'Đa khoa', label: 'Đa khoa' },

    { value: 'Khác', label: 'Khác' },
];

const SELECT_TEN_CHUNG_CHI_TYPES_DIEUDUONG = [
    'Tiến sĩ', 'Thạc sĩ', 'Chuyên khoa II', 'Chuyên khoa I', 'Đại học', 'Cao đẳng', 'Trung cấp', 'Kỹ thuật Y', 'Văn bằng chuyên khoa'
];

const loaiGiayPhepSelectOptions = LOAI_GIAY_PHEP_OPTIONS.map((item) => ({ value: String(item.value), label: item.label }));
const noiCapSelectOptions = NOI_CAP_OPTIONS.map((item) => ({ value: String(item.value), label: item.label }));

const normalizePagedData = (res) => {
    const raw = res?.data?.$values ? res.data.$values : res?.data || [];
    return Array.isArray(raw) ? raw : [];
};

const toInputDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const isEmptyChungChi = (item = {}) => {
    return !item.loaiChungChi && !item.tenChungChi && !item.ngayCap && !item.fileMinhChungId && !item.fileMinhChungPath && !item.ghiChu;
};

const isImageFile = (filePath = '') => {
    return /\.(jpeg|jpg|gif|png|jpe)$/i.test(filePath);
};

// HÀM KIỂM TRA CHỨNG CHỈ CÓ BỊ KHÓA KHÔNG
const isLockedStatus = (status) => {
    if (status === null || status === undefined || status === '') return false;
    if (typeof status === 'number') {
        return status === 1 || status === 2;
    }
    const strStatus = String(status).toLowerCase().trim();
    return strStatus === '1' || strStatus === 'đã duyệt' || strStatus === 'da duyet' ||
        strStatus === '2' || strStatus === 'từ chối' || strStatus === 'tu choi';
};

// HÀM TẠO NHÃN TRẠNG THÁI HIỂN THỊ TRÊN CỘT THAO TÁC CÓ MÀU ĐÚNG THEO DB
const renderLockedBadge = (status) => {
    let isApproved = false;
    let isRejected = false;

    if (typeof status === 'number') {
        if (status === 1) isApproved = true;
        if (status === 2) isRejected = true;
    } else if (status) {
        const strStatus = String(status).toLowerCase().trim();
        if (strStatus === '1' || strStatus === 'đã duyệt' || strStatus === 'da duyet') isApproved = true;
        if (strStatus === '2' || strStatus === 'từ chối' || strStatus === 'tu choi') isRejected = true;
    }

    if (isApproved) {
        return (
            <span className="badge bg-success p-2 fw-normal" style={{ fontSize: '13px' }}>
                <i className="fas fa-check-circle me-1"></i> Đã duyệt
            </span>
        );
    }
    if (isRejected) {
        return (
            <span className="badge bg-danger p-2 fw-normal" style={{ fontSize: '13px' }}>
                <i className="fas fa-times-circle me-1"></i> Từ chối
            </span>
        );
    }
    return (
        <span className="badge bg-secondary p-2 fw-normal" style={{ fontSize: '13px' }}>
            Đã khóa
        </span>
    );
};

const uploadFileToServer = async ({ fileUpload, setCompleted }) => {
    const token = await getToken();
    const config = {
        onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setCompleted(percentCompleted);
        },
        headers: { 'Content-Type': 'multipart/form-data', Authorization: `bearer ${token}` }
    };
    const data = new FormData();
    data.append('file', fileUpload);
    return axios.post(FILE_MANAGER_API.UPLOAD, data, config);
};

const getSelectStyles = (isInvalid = false, isDisabled = false) => ({
    control: (base, state) => ({
        ...base,
        minHeight: '38px',
        borderRadius: '0.25rem',
        backgroundColor: isDisabled ? '#e9ecef' : '#fff', // Màu xám nếu disable
        borderColor: isInvalid ? '#dc3545' : state.isFocused ? '#86b7fe' : '#ced4da',
        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.25)' : 'none',
        '&:hover': { borderColor: isInvalid ? '#dc3545' : state.isFocused ? '#86b7fe' : '#ced4da' }
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    valueContainer: (base) => ({ ...base, paddingTop: '2px', paddingBottom: '2px' }),
    multiValue: (base) => ({ ...base, borderRadius: '12px' }),
    multiValueLabel: (base) => ({ ...base, fontSize: '13px' }),
    placeholder: (base) => ({ ...base, color: '#6c757d' })
});

const FileMinhChungField = ({ value, onChange, inTable = false, disabled = false }) => {
    const inputUpload = useRef(null);
    const [completed, setCompleted] = useState(0);
    const [fileInfo, setFileInfo] = useState({ id: '', filePath: '', name: '' });

    useEffect(() => {
        setFileInfo({ id: value?.id || '', filePath: value?.filePath || '', name: value?.name || '' });
    }, [value]);

    const handleUploadFile = async (event) => {
        if (disabled) return;
        const fileUpload = event.target.files?.[0];
        if (!fileUpload) return;
        const fileSize = fileUpload.size / 1024 / 1024;
        if (fileSize > 20) {
            toast.error('Kích thước file quá lớn, hãy thử lại với tệp nhỏ hơn 20MB');
            return;
        }

        try {
            const result = await uploadFileToServer({ fileUpload, setCompleted });
            const uploaded = result?.data?.[0];
            if (!uploaded) {
                toast.error('Không nhận được dữ liệu file sau khi tải lên');
                setCompleted(0);
                return;
            }
            const normalized = {
                id: uploaded.id || uploaded.Id || '',
                filePath: uploaded.filePath || uploaded.FilePath || '',
                name: uploaded.name || uploaded.Name || fileUpload.name
            };
            setFileInfo(normalized);
            onChange(normalized);
            setCompleted(0);
            toast.success('Tải file thành công!');
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Tải file thất bại');
            setCompleted(0);
        } finally {
            if (inputUpload.current) inputUpload.current.value = '';
        }
    };

    const handleRemove = () => {
        if (disabled) return;
        const emptyFile = { id: '', filePath: '', name: '' };
        setFileInfo(emptyFile);
        onChange(emptyFile);
    };

    const handleOpenFile = () => {
        if (!fileInfo.filePath) return;
        window.open(`${BaseGatewayImage}${fileInfo.filePath}`, '_blank');
    };

    const isUploaded = fileInfo.filePath && completed === 0;

    const renderImagePreview = () => {
        if (!fileInfo.filePath || !isImageFile(fileInfo.filePath)) return null;
        return (
            <div style={{
                border: '1px solid #dee2e6', borderRadius: inTable ? '8px' : '14px',
                padding: inTable ? '4px' : '12px', background: '#fff', marginBottom: '10px', textAlign: inTable ? 'center' : 'left'
            }}>
                <img src={`${BaseGatewayImage}${fileInfo.filePath}`} alt={fileInfo.name || 'file minh chứng'}
                    style={{ maxWidth: inTable ? '100px' : '240px', maxHeight: inTable ? '100px' : '180px', objectFit: 'contain', borderRadius: '8px' }} />
            </div>
        );
    };

    const displayFileName = fileInfo.name || (fileInfo.filePath ? fileInfo.filePath.split('/').pop() : '');
    const uploadArea = (
        <div style={{ border: '1px solid #dee2e6', borderRadius: inTable ? '8px' : '14px', padding: inTable ? '8px' : '16px', background: '#fff' }}>
            <div className={`d-flex flex-wrap align-items-center justify-content-${inTable ? 'center' : 'start'} ${inTable ? 'gap-2' : 'mb-3'}`}>
                {!disabled && (
                    <Button type="button" theme="primary" size={inTable ? 'sm' : 'md'} onClick={() => inputUpload.current?.click()}>Upload</Button>
                )}
                {!inTable && !disabled && <div className="ml-3 mr-3 text-muted">Dung lượng tối đa: 20MB</div>}

                <Button type="button" theme="secondary" size={inTable ? 'sm' : 'md'} onClick={handleOpenFile} disabled={!fileInfo.filePath}>
                    Xem
                </Button>

                {!disabled && (
                    <Button type="button" theme="danger" size={inTable ? 'sm' : 'md'} onClick={handleRemove} disabled={!fileInfo.filePath} style={{ marginLeft: '4px' }}>Xóa</Button>
                )}
            </div>
            {!disabled && <Form.Control type="file" hidden accept={acceptDoc} ref={inputUpload} onChange={handleUploadFile} />}
            {!inTable && <Form.Control value={fileInfo.filePath || ''} readOnly placeholder="Chưa có file minh chứng" />}

            {displayFileName && (
                <div className="mt-2 text-muted" style={{ fontSize: inTable ? '12px' : '14px', wordBreak: 'break-all', textAlign: inTable ? 'center' : 'left' }}>
                    {inTable ? '' : 'Tên file: '}<strong>{displayFileName}</strong>
                </div>
            )}
            {!disabled && <ProgressBar className="mt-3" style={{ display: isUploaded ? 'none' : 'flex' }} variant="success" animated now={completed} />}
        </div>
    );

    if (inTable) return <div>{renderImagePreview()}{uploadArea}</div>;

    return (
        <>
            {fileInfo.filePath && isImageFile(fileInfo.filePath) && <Row className="mb-3"><Col md={{ span: 10, offset: 2 }}>{renderImagePreview()}</Col></Row>}
            <Form.Group as={Row} className="mb-3">
                <Form.Label className="col-sm-2 col-form-label">File minh chứng</Form.Label>
                <Col sm="10">{uploadArea}</Col>
            </Form.Group>
        </>
    );
};

const schema = yup.object().shape({
    loaiGiayPhep: yup.string().required('Loại giấy phép không được để trống'),
    noiCap: yup.string().required('Nơi cấp không được để trống'),
    soGiayPhep: yup.string().required('Số giấy phép không được để trống').max(100, 'Số giấy phép không được vượt quá 100 ký tự'),
    chucDanh: yup.string().required('Chức danh không được để trống'),
    ngayCap: yup.string().required('Ngày cấp không được để trống'),
    ngayHetHan: yup.string().nullable().test(
        'ngayHetHan', 'Ngày hết hạn phải lớn hơn hoặc bằng ngày cấp',
        function (value) {
            const { ngayCap } = this.parent;
            if (!value || !ngayCap) return true;
            return new Date(value) >= new Date(ngayCap);
        }
    ),
    phamViHanhNgheIds: yup.array().min(1, 'Bạn phải chọn ít nhất 1 phạm vi hành nghề'),
    chungChiChuyenMons: yup.array().of(
        yup.object().shape({
            loaiChungChi: yup.string(),
            tenChungChi: yup.string(),
            ghiChu: yup.string().nullable(),
            ngayCap: yup.string().nullable()
        }).test(
            'chung-chi-nothing-or-complete',
            'Thông tin chứng chỉ chuyên môn chưa đầy đủ',
            function (value) {
                if (!value || isEmptyChungChi(value)) return true;
                return !!value.loaiChungChi && !!value.tenChungChi && !!value.ngayCap;
            }
        )
    )
});

const SectionBlock = ({ title, children }) => (
    <div style={{ border: '1px solid #e8edf3', borderRadius: '16px', padding: '18px', marginBottom: '18px', background: '#fff' }}>
        <div style={{ fontSize: '16px', fontWeight: 700, marginBottom: '16px', color: '#0d6efd' }}>{title}</div>
        {children}
    </div>
);

const renderError = (error) => error ? <div className="text-danger" style={{ fontSize: '13px', marginTop: '6px' }}>{error}</div> : null;

const GiayPhepHanhNgheForm = ({ title, submitText, initialValues, onSubmit, onCancel, isSubmitting, tenDoiTuong }) => {

    const targetName = String(tenDoiTuong || '').toLowerCase();
    const isBacSi = targetName.includes('bác sĩ');
    const isDieuDuong = targetName.includes('điều dưỡng') || targetName.includes('kỹ thuật y') || targetName.includes('y sĩ') || targetName.includes('y sỹ') || targetName.includes('hộ sinh');

    const loaiChungChiOptions = useMemo(() => {
        if (isBacSi) {
            return [
                { value: 'Bác sĩ', label: 'Bác sĩ' }, 
                { value: 'Thạc sĩ', label: 'Thạc sĩ' }, 
                { value: 'Tiến sĩ', label: 'Tiến sĩ' },
                { value: 'Chuyên khoa I', label: 'Chuyên khoa I' }, 
                { value: 'Chuyên khoa II', label: 'Chuyên khoa II' }, 
                { value: 'Nội trú', label: 'Nội trú' },
                { value: 'Chứng chỉ chuyên môn kỹ thuật trên 09 tháng', label: 'Chứng chỉ chuyên môn kỹ thuật trên 09 tháng' },
                { value: 'Chứng chỉ chuyên môn kỹ thuật dưới 09 tháng', label: 'Chứng chỉ chuyên môn kỹ thuật dưới 09 tháng' }, 
                { value: 'Khác', label: 'Khác' }
            ];
        }
        if (isDieuDuong) {
            return [
                { value: 'Tiến sĩ', label: 'Tiến sĩ' }, 
                { value: 'Chuyên khoa II', label: 'Chuyên khoa II' },
                { value: 'Thạc sĩ', label: 'Thạc sĩ' }, 
                { value: 'Chuyên khoa I', label: 'Chuyên khoa I' }, 
                { value: 'Đại học', label: 'Đại học' }, 
                { value: 'Cao đẳng', label: 'Cao đẳng' },
                { value: 'Trung cấp', label: 'Trung cấp' }, 
                { value: 'Kỹ thuật Y', label: 'Kỹ thuật Y' },
                { value: 'Chứng chỉ kỹ thuật chuyên môn về khám bệnh, chữa bệnh', label: 'Chứng chỉ kỹ thuật chuyên môn về khám bệnh, chữa bệnh' },
                { value: 'Khác', label: 'Khác' }
            ];
        }
        return [{ value: 'Khác', label: 'Khác' }];
    }, [isBacSi, isDieuDuong]);

    const phamViHanhNgheQuery = useQuery(['phamViHanhNghe-lookup'], () => Get(PHAMVIHANHNGHE_API.GET_PAGING, null, { Keyword: '', PageIndex: 1, PageSize: 1000 }));
    const isLookupLoading = phamViHanhNgheQuery.isLoading;
    const phamViHanhNgheOptions = useMemo(() => normalizePagedData(phamViHanhNgheQuery.data), [phamViHanhNgheQuery.data]);
    const phamViHanhNgheSelectOptions = useMemo(() => phamViHanhNgheOptions.map((item) => ({ value: String(item.id || item.Id), label: item.tenPhamViHanhNghe || item.TenPhamViHanhNghe || 'Không có tên' })), [phamViHanhNgheOptions]);

    if (isLookupLoading) {
        return (
            <Card style={{ borderRadius: '16px' }}><Card.Body className="text-center py-5"><Spinner animation="border" variant="primary" /><div className="mt-3">Đang tải dữ liệu danh mục...</div></Card.Body></Card>
        );
    }

    return (
        <Card style={{ borderRadius: '16px' }}>
            <Card.Header as="h5" style={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px', padding: '16px 20px', fontWeight: 700 }}>{title}</Card.Header>
            <Card.Body style={{ background: '#f8f9fb' }}>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    initialValues={{
                        loaiGiayPhep: initialValues.loaiGiayPhep !== undefined && initialValues.loaiGiayPhep !== null ? String(initialValues.loaiGiayPhep) : '',
                        noiCap: initialValues.noiCap !== undefined && initialValues.noiCap !== null ? String(initialValues.noiCap) : '',
                        soGiayPhep: initialValues.soGiayPhep || '',
                        chucDanh: initialValues.chucDanh || tenDoiTuong || '',
                        ngayCap: toInputDate(initialValues.ngayCap),
                        ngayHetHan: toInputDate(initialValues.ngayHetHan),
                        trangThai: initialValues.trangThai !== undefined && initialValues.trangThai !== null ? initialValues.trangThai : '',
                        phamViHanhNgheIds: (initialValues.phamViHanhNgheIds || []).map((x) => String(x)),
                        fileMinhChungId: initialValues.fileMinhChungId || '',
                        fileMinhChungPath: initialValues.fileMinhChungPath || '',
                        fileMinhChungName: initialValues.fileMinhChungName || '',
                        chungChiChuyenMons: (initialValues.chungChiChuyenMons || []).filter((cc) => !isEmptyChungChi(cc)).map(cc => ({
                            id: cc.id || '',
                            accountInfoId: cc.accountInfoId || '',
                            loaiChungChi: cc.loaiChungChi || '',
                            tenChungChi: cc.tenChungChi || '',
                            ghiChu: cc.ghiChu || cc.GhiChu || '',
                            ngayCap: cc.ngayCap || '',
                            fileMinhChungId: cc.fileMinhChungId || '',
                            fileMinhChungPath: cc.fileMinhChungPath || '',
                            fileMinhChungName: cc.fileMinhChungName || '',
                            trangThai: cc.trangThai ?? cc.TrangThai ?? null
                        })),
                        deletedCccmIds: []
                    }}
                    onSubmit={onSubmit}
                >
                    {({ handleSubmit, handleChange, values, errors, touched, submitCount, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <SectionBlock title="Thông tin giấy phép hành nghề">
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">Loại giấy phép</Form.Label>
                                    <Col sm="4">
                                        <Select
                                            inputId="loaiGiayPhep" isSearchable={false} isClearable={false} placeholder="Loại giấy phép"
                                            noOptionsMessage={() => 'Không có dữ liệu'} options={loaiGiayPhepSelectOptions}
                                            value={loaiGiayPhepSelectOptions.find((item) => item.value === String(values.loaiGiayPhep || '')) || null}
                                            onChange={(selectedOption) => setFieldValue('loaiGiayPhep', selectedOption?.value || '')}
                                            styles={getSelectStyles(!!(touched.loaiGiayPhep && errors.loaiGiayPhep))}
                                        />
                                        {renderError(touched.loaiGiayPhep && errors.loaiGiayPhep)}
                                    </Col>

                                    <Form.Label className="col-sm-2 col-form-label">Nơi cấp</Form.Label>
                                    <Col sm="4">
                                        <Select
                                            inputId="noiCap" isSearchable={false} isClearable={false} placeholder="Nơi cấp"
                                            noOptionsMessage={() => 'Không có dữ liệu'} options={noiCapSelectOptions}
                                            value={noiCapSelectOptions.find((item) => item.value === String(values.noiCap || '')) || null}
                                            onChange={(selectedOption) => setFieldValue('noiCap', selectedOption?.value || '')}
                                            styles={getSelectStyles(!!(touched.noiCap && errors.noiCap))}
                                        />
                                        {renderError(touched.noiCap && errors.noiCap)}
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">Số giấy phép</Form.Label>
                                    <Col sm="4">
                                        <Form.Control name="soGiayPhep" value={values.soGiayPhep} onChange={handleChange} isInvalid={!!(touched.soGiayPhep && errors.soGiayPhep)} placeholder="Nhập số giấy phép" />
                                        {renderError(touched.soGiayPhep && errors.soGiayPhep)}
                                    </Col>

                                    <Form.Label className="col-sm-2 col-form-label">Ngày cấp</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="date" name="ngayCap" value={values.ngayCap} onChange={handleChange} isInvalid={!!(touched.ngayCap && errors.ngayCap)} />
                                        {renderError(touched.ngayCap && errors.ngayCap)}
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">Chức danh</Form.Label>
                                    <Col sm="4">
                                        <Form.Control name="chucDanh" value={values.chucDanh} readOnly style={{ backgroundColor: '#e9ecef', color: '#495057' }} placeholder="Chức danh sẽ được tự động lấy từ dữ liệu" />
                                    </Col>

                                    <Form.Label className="col-sm-2 col-form-label">Ngày hết hạn</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="date" name="ngayHetHan" value={values.ngayHetHan} onChange={handleChange} isInvalid={!!(touched.ngayHetHan && errors.ngayHetHan)} />
                                        {renderError(touched.ngayHetHan && errors.ngayHetHan)}
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">Phạm vi hành nghề</Form.Label>
                                    <Col sm="10">
                                        <Select
                                            inputId="phamViHanhNgheIds" isMulti isSearchable closeMenuOnSelect={false} hideSelectedOptions={false}
                                            placeholder="Chọn phạm vi hành nghề" noOptionsMessage={() => 'Không có dữ liệu'} options={phamViHanhNgheSelectOptions}
                                            value={phamViHanhNgheSelectOptions.filter((item) => values.phamViHanhNgheIds.includes(item.value))}
                                            onChange={(selectedOptions) => setFieldValue('phamViHanhNgheIds', (selectedOptions || []).map((item) => item.value))}
                                            styles={getSelectStyles(submitCount > 0 && !!errors.phamViHanhNgheIds)}
                                        />
                                        {renderError(submitCount > 0 && errors.phamViHanhNgheIds)}
                                    </Col>
                                </Form.Group>

                                <div className="mb-4">
                                    <FileMinhChungField
                                        value={{ id: values.fileMinhChungId, filePath: values.fileMinhChungPath, name: values.fileMinhChungName }}
                                        onChange={(file) => {
                                            setFieldValue('fileMinhChungId', file?.id || '');
                                            setFieldValue('fileMinhChungPath', file?.filePath || '');
                                            setFieldValue('fileMinhChungName', file?.name || '');
                                        }}
                                    />
                                </div>
                            </SectionBlock>

                            <SectionBlock title="Thông tin Văn bằng và Chứng chỉ chuyên môn">
                                <FieldArray name="chungChiChuyenMons">
                                    {({ push, remove }) => (
                                        <div>
                                            <Table bordered hover responsive style={{ background: '#fff' }}>
                                                <thead className="table-light">
                                                    <tr>
                                                        <th style={{ width: '18%' }}>Loại</th>
                                                        <th style={{ width: '20%' }}>Tên</th>
                                                        <th style={{ width: '15%' }}>Ghi chú</th>
                                                        <th style={{ width: '15%' }}>Ngày cấp</th>
                                                        <th style={{ width: '20%' }}>File minh chứng</th>
                                                        <th style={{ width: '12%' }} className="text-center">Thao tác</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {values.chungChiChuyenMons && values.chungChiChuyenMons.length > 0 ? (
                                                        values.chungChiChuyenMons.map((item, index) => {

                                                            const isLocked = isLockedStatus(item.trangThai);
                                                            const isSelectTenChungChi = (isBacSi && SELECT_TEN_CHUNG_CHI_TYPES_BACSI.includes(item.loaiChungChi)) || (isDieuDuong && SELECT_TEN_CHUNG_CHI_TYPES_DIEUDUONG.includes(item.loaiChungChi));
                                                            const currentTenChungChiOptions = isBacSi ? TEN_CHUNG_CHI_OPTIONS_BACSI : isDieuDuong ? TEN_CHUNG_CHI_OPTIONS_DIEUDUONG : [];

                                                            return (
                                                                <tr key={index}>
                                                                    <td className="align-middle">
                                                                        <Select
                                                                            inputId={`chungChiChuyenMons_${index}_loaiChungChi`} isSearchable={false} isClearable={false}
                                                                            isDisabled={isLocked}
                                                                            placeholder="Chọn loại" noOptionsMessage={() => 'Không có dữ liệu'} options={loaiChungChiOptions}
                                                                            value={loaiChungChiOptions.find((opt) => opt.value === String(item.loaiChungChi || '')) || null}
                                                                            onChange={(selectedOption) => {
                                                                                setFieldValue(`chungChiChuyenMons.${index}.loaiChungChi`, selectedOption?.value || '');
                                                                                setFieldValue(`chungChiChuyenMons.${index}.tenChungChi`, '');
                                                                            }}
                                                                            styles={getSelectStyles(!!(touched.chungChiChuyenMons?.[index]?.loaiChungChi && errors.chungChiChuyenMons?.[index]?.loaiChungChi), isLocked)}
                                                                            menuPortalTarget={document.body} menuPosition={'fixed'}
                                                                        />
                                                                        {renderError(touched.chungChiChuyenMons?.[index]?.loaiChungChi && errors.chungChiChuyenMons?.[index]?.loaiChungChi)}
                                                                    </td>
                                                                    <td className="align-middle">
                                                                        {isSelectTenChungChi ? (
                                                                            <>
                                                                                <Select
                                                                                    inputId={`chungChiChuyenMons_${index}_tenChungChi`}
                                                                                    isDisabled={isLocked}
                                                                                    isSearchable={true} isClearable={true} placeholder="Chọn tên chứng chỉ" noOptionsMessage={() => 'Không có dữ liệu'}
                                                                                    options={currentTenChungChiOptions}
                                                                                    value={currentTenChungChiOptions.find((opt) => opt.value === String(item.tenChungChi || '')) || null}
                                                                                    onChange={(selectedOption) => setFieldValue(`chungChiChuyenMons.${index}.tenChungChi`, selectedOption?.value || '')}
                                                                                    styles={getSelectStyles(!!(touched.chungChiChuyenMons?.[index]?.tenChungChi && errors.chungChiChuyenMons?.[index]?.tenChungChi), isLocked)}
                                                                                    menuPortalTarget={document.body} menuPosition={'fixed'}
                                                                                />
                                                                                {renderError(touched.chungChiChuyenMons?.[index]?.tenChungChi && errors.chungChiChuyenMons?.[index]?.tenChungChi)}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <Form.Control
                                                                                    name={`chungChiChuyenMons.${index}.tenChungChi`}
                                                                                    value={item.tenChungChi} onChange={handleChange} placeholder="Nhập tên"
                                                                                    disabled={isLocked}
                                                                                    isInvalid={!!(touched.chungChiChuyenMons?.[index]?.tenChungChi && errors.chungChiChuyenMons?.[index]?.tenChungChi)}
                                                                                />
                                                                                {renderError(touched.chungChiChuyenMons?.[index]?.tenChungChi && errors.chungChiChuyenMons?.[index]?.tenChungChi)}
                                                                            </>
                                                                        )}
                                                                    </td>
                                                                    <td className="align-middle">
                                                                        <Form.Control
                                                                            name={`chungChiChuyenMons.${index}.ghiChu`}
                                                                            value={item.ghiChu || ''}
                                                                            onChange={handleChange}
                                                                            placeholder="Nhập ghi chú"
                                                                            disabled={isLocked}
                                                                        />
                                                                    </td>
                                                                    <td className="align-middle">
                                                                        <Form.Control
                                                                            type="date" name={`chungChiChuyenMons.${index}.ngayCap`} value={item.ngayCap ? toInputDate(item.ngayCap) : ''} onChange={handleChange}
                                                                            disabled={isLocked}
                                                                            isInvalid={!!(touched.chungChiChuyenMons?.[index]?.ngayCap && errors.chungChiChuyenMons?.[index]?.ngayCap)}
                                                                        />
                                                                        {renderError(touched.chungChiChuyenMons?.[index]?.ngayCap && errors.chungChiChuyenMons?.[index]?.ngayCap)}
                                                                    </td>
                                                                    <td className="align-middle">
                                                                        <FileMinhChungField
                                                                            inTable={true}
                                                                            disabled={isLocked}
                                                                            value={{ id: item.fileMinhChungId, filePath: item.fileMinhChungPath, name: item.fileMinhChungName }}
                                                                            onChange={(file) => {
                                                                                setFieldValue(`chungChiChuyenMons.${index}.fileMinhChungId`, file?.id || '');
                                                                                setFieldValue(`chungChiChuyenMons.${index}.fileMinhChungPath`, file?.filePath || '');
                                                                                setFieldValue(`chungChiChuyenMons.${index}.fileMinhChungName`, file?.name || '');
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td className="align-middle text-center">
                                                                        {isLocked ? (
                                                                            renderLockedBadge(item.trangThai)
                                                                        ) : (
                                                                            <Button
                                                                                type="button" theme="danger" size="sm"
                                                                                onClick={() => {
                                                                                    if (item.id) {
                                                                                        const currentDeletedIds = values.deletedCccmIds || [];
                                                                                        setFieldValue('deletedCccmIds', [...currentDeletedIds, item.id]);
                                                                                    }
                                                                                    remove(index);
                                                                                }}
                                                                            >
                                                                                Xóa
                                                                            </Button>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr><td colSpan="6" className="text-center text-muted py-4">Chưa có chứng chỉ chuyên môn nào được thêm.</td></tr>
                                                    )}
                                                </tbody>
                                            </Table>

                                            <div className="d-flex justify-content-start mt-3">
                                                <Button type="button" theme="info" onClick={() => push({ id: '', loaiChungChi: '', tenChungChi: '', ghiChu: '', ngayCap: '', fileMinhChungId: '', fileMinhChungPath: '', fileMinhChungName: '', trangThai: null })}>
                                                    + Thêm chứng chỉ
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </FieldArray>
                            </SectionBlock>

                            <div className="d-flex justify-content-center mt-4 mb-2">
                                <ButtonGroup>
                                    <Button type="submit" theme="primary" disabled={isSubmitting}>{submitText}</Button>
                                    &nbsp;&nbsp;&nbsp;
                                    <Button type="button" theme="secondary" onClick={onCancel}>Hủy</Button>
                                </ButtonGroup>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default GiayPhepHanhNgheForm;